import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { isNullOrUndefined } from 'util';
import { filter } from 'rxjs/operators';
import { MenuItem } from 'primeng/primeng';

@Component({
  selector: 'app-ariane',
  templateUrl: './ariane.component.html',
  styleUrls: ['./ariane.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ArianeComponent implements OnInit {

  private static readonly ROUTE_DATA_BREADCRUMB = 'breadcrumb';
  public menuItems: MenuItem[];

  constructor(public router: Router, private activatedRoute: ActivatedRoute) {
  }

  public ngOnInit() {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
          this.menuItems = this.createBreadcrumbs(this.activatedRoute.root);
        }
      );
  }

  public activeMenu(event) {
    let node;
    if (event.target.tagName === 'A') {
      node = event.target;
      event.target.classList.remove('home-active');
      event.target.classList.add('active');
    } else {
      node = event.target.parentNode;
    }
    const menuitem = document.getElementsByClassName('ui-menuitem-link');
    for (let i = 0; i < menuitem.length; i++) {
      menuitem[i].classList.remove('active');
    }
    node.classList.add('active');
  }

  private createBreadcrumbs(route: ActivatedRoute, url: string = '#', breadcrumbs: MenuItem[] = []): MenuItem[] {
    const children: ActivatedRoute[] = route.children;

    if (children.length === 0) {
      return breadcrumbs;
    }

    for (const child of children) {
      const routeURL: string = child.snapshot.url.map(segment => segment.path).join('/#');
      if (routeURL !== '') {
        if (routeURL === 'resultat') {
          url = `/#/verifier/${routeURL}`;
        } else {
          url = `/#/${routeURL}`;
        }
      }

      if (breadcrumbs.length === 0) {
        const label = 'breadcrumb.home';
        const hash = '/#/accueil';
        if (!isNullOrUndefined(label)) {
          breadcrumbs.push({label, url: hash});
        }
      } else {
        const label = child.snapshot.data[ArianeComponent.ROUTE_DATA_BREADCRUMB];
        if (!isNullOrUndefined(label)) {
          breadcrumbs.push({label, url});
        }
      }

      return this.createBreadcrumbs(child, url, breadcrumbs);
    }
  }
}
